import {
  Component,
  ViewChild,
  TemplateRef,
  Inject,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import { CompsDataService } from "../../comps-page/comps-data.service";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { AppService } from "src/app/app.service";
import { MARKETDATA_COPYRIGHT_MESSAGE } from "src/app/common-constants";
import { NzModalService, NzModalRef } from "ng-zorro-antd/modal";
import { getSelectedPeriods } from "src/app/utils/period-utils";
import {
  ValuationGridData,
  ValuationPeriodState,
  UserSettingObject,
} from "src/app/valuation-page/valuation-page.model";
import { ValuationPageDataService } from "src/app/valuation-page/valuation-page-data.service";
import {
  getSelectedRatiosId,
  getIsDenomSelected,
  getIsDenomYoySelected,
  createGridData,
  createComparativeDataCallUrlV1,
} from "src/app/valuation-page/valuation-page-utils";
import {
  createDataCallUrlForMcapEvLp,
  updateCustomTableSettingsForTickers,
} from "../comparative-analysis-utils";
import { LineItemModalComponent } from "src/app/shared/line-item-modal/line-item-modal.component";
import {
  PeriodState,
  PeriodUserSettingObj,
  convertPeriodMetaToUserSettings,
} from "@va/core-library/period-filter";
import { Router } from "@angular/router";
import { DOCUMENT } from "@angular/common";
import { INDUSTRY_PAGE_INFO } from "src/app/sectors-and-industries-page/sector-and-industry-page-constants";
import { CustomSkeletonConfig } from "src/app/shared/custom-skeleton/custom-skeleton-model";
import { faThLarge, faTimes } from "@fortawesome/pro-light-svg-icons";
import { Observable, Subscription, from, BehaviorSubject } from "rxjs";
import { mergeMap } from "rxjs/operators";
import {
  VAIconRegistryService,
  check,
  close,
  closeCircle,
  infoCircle,
  menu,
} from "@va/core-library/icons";
import {
  getMetaPayloadFromUrls,
  updateCustomTableSettings,
  createValuationTabUserSettings,
} from "src/app/comparative-analysis/comparative-analysis-utils";
import { ComparativeAnalysisService } from "./../comparative-analysis.service";
import { ComparativeTickerModalComponent } from "../comparative-ticker-modal/comparative-ticker-modal.component";
import { AddWatchlistData } from "src/app/store/actions/global.actions";
import { WatchlistService } from "src/app/watchlist/watchlist.service";
import { TAB_BE_MAPPING } from "../constants";
import { DeleteDpParams } from "src/app/store/actions/global-subheader.actions";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-comparative-valuation",
  templateUrl: "./comparative-valuation.component.html",
  styleUrls: ["./comparative-valuation.component.scss"],
})
export class ComparativeValuationComponent {
  @Input() isActive = true;
  @Input() state;
  @Input() shouldFetchData = false;
  @Input() sortByColumnId;
  @Output() updateValuationState: EventEmitter<any> = new EventEmitter();
  @Output() onDataFetchInitiate: EventEmitter<any> = new EventEmitter();
  @Output() updateGridSortByColumnId: EventEmitter<any> = new EventEmitter();
  @Input() routeParams;
  @Input() routeQueryParams;
  @Input() pageType;
  @Input() compType;
  @Input() compId;
  @Input() recentlyVisitedCompanies;
  @Input() watchlistData;
  @Input() industryMenuData;
  @Input() suggestedPeers;
  @Input() tickerModalDataReady;
  @Input() marketGeoData;
  @Output() initiateWatchlistFetch: EventEmitter<any> = new EventEmitter();
  @Output() updateUnsavedDataStatus: EventEmitter<any> = new EventEmitter();

  //icons
  faThLarge = faThLarge;
  faTimes = faTimes;

  // loaders
  isMetaInProgress = true;
  isDataInProgress = true;
  isMarketDataInProgress = false;

  isUserSettingUpdateInProgress = false;
  isExportInProgress = false;
  isLineItemUpdateInProgress = false;

  //page related variables
  tabType = "Valuation";

  // filters data
  sector;
  industry;
  ratioLineItemsData = [];
  suggestedRatioLines = [];
  ratios;
  orderedRatioData;
  tickers = [];
  currency = "";
  periodData: PeriodState = undefined;
  periodUserSetting: PeriodUserSettingObj = undefined;
  userSettingDetails: UserSettingObject;
  periodCalculation;
  orientationValue = "grid";
  periodsWithAvailableData;

  // instance variables
  shouldFetchMeta;
  isComparativeAnalysisCall: boolean = true;
  calculateFooterDataForMCapAndEV: boolean = false;
  headerTitle: string = "";
  pageShortName = INDUSTRY_PAGE_INFO.valuation.shortName;
  industryId: number;
  gridData: ValuationGridData = undefined;
  magnitudeMessage;
  periodList: Array<string>;
  lineItemMaxLimit = 20;
  selectedLineItemCount = 0;
  selectedRatioId;
  highlightGAAP = false;
  lineItemsModal: NzModalRef;
  excelToExportDropdownOptions = [
    {
      label: "Values",
      id: 1,
      disabled: false,
    },
    {
      label: "Excel Add-In Formulas",
      id: 0,
      disabled: false,
    },
  ];
  skeletonDefaultConfig: CustomSkeletonConfig = {
    skeletonType: "default",
  };
  marketDataCopyRightMessage = MARKETDATA_COPYRIGHT_MESSAGE;
  marketDataAccess = false;
  apiEP: string = window.apiUrl;
  marketCap = [-1];
  region = [-1];
  countries;
  subGroup = -1;
  tickerLimit = 500;
  tickersModal: NzModalRef;
  storeDataKey = "watchlist";
  periodMinMax = { min: -10, max: 9 };
  disableTickerDeletionOnGrid: boolean = true;
  assets = environment.assetUrl;
  overlayOn = false;
  sortedTickers;
  gridSortByColumnId;

  //popovers
  isMegaMenuVisible = false;
  regionPopoverOpen = false;
  isExportPopoverVisible = false;
  isNoTickerPopupVisible = false;

  //snackbar
  snackbarInfo: { message: string; type: string } = {
    message: "",
    type: "info",
  };
  snackBarRef: MatSnackBarRef<any>;
  snackbarMessage = "";

  //urls
  legacyUrl = `${window.caUrl}/app`;

  //subscribers
  routeParamSubscriber: Subscription;
  sectorIndustryStoreSubscriber: Subscription;
  sectorIndustryStoreReloadSubscriber: Subscription;
  sectorIndustryStoreHasDataSubscriber: Subscription;
  sectorMetaSubscriber: Subscription;
  industryDetailsSubscriber: Subscription;
  globalAppSettingSubscriber: Subscription;
  valuationMetaSubscriber: Subscription;
  valuationDataSubscriber: Subscription;
  valuationMcapEvLpriceDataSubscriber: Subscription;
  valuationMcapEvLpriceFirstBatchSubscriber: Subscription;
  valuationMcapEvLpriceSecondBatchSubscriber: Subscription;
  valuationDataFirstBatchSubscriber: Subscription;
  valuationDataSecondBatchSubscriber: Subscription;
  userTabSettingsSubscriber: Subscription;
  userIndustrySettingsSubscriber: Subscription;
  lineItemsSubscriber: Subscription;
  currencyMessageSubscriber: Subscription;

  //observer
  valuationGridData$: BehaviorSubject<any>;

  @ViewChild("successTemplate") successTemplate: TemplateRef<any>;
  @ViewChild("failureTemplate") failureTemplate: TemplateRef<any>;
  @ViewChild("infoTemplate") infoTemplate: TemplateRef<any>;
  @ViewChild("warningTemplate") warningTemplate: TemplateRef<any>;

  constructor(
    private dataService: ComparativeAnalysisService,
    private store: Store<AppState>,
    private snackBar: MatSnackBar,
    public router: Router,
    private appService: AppService,
    private valuationDataService: ValuationPageDataService,
    private modalService: NzModalService,
    private compsDataService: CompsDataService,
    private iconRegistry: VAIconRegistryService,
    private watchlistDataService: WatchlistService,
    @Inject(DOCUMENT) private _document: HTMLDocument,
  ) {
    this.valuationGridData$ = new BehaviorSubject<any>(null);
    this.iconRegistry.registerIcons([
      menu,
      check,
      close,
      closeCircle,
      infoCircle,
    ]);
  }

  ngOnInit() {
    this.globalAppSettingSubscriber = this.store
      .select(
        stateGetter("globalHeader", "globalAppSettings", "period_settings"),
      )
      .subscribe((data) => {
        if (data) {
          //raise update of common state to trigger data calls on all tabs
          if (!this.isMetaInProgress && this.gridData && this.isActive) {
            this.fetchAndHandleValuationData();
          }
        }
      });
  }

  /**
   * Unsubscribes from store when component is destroyed
   */
  ngOnDestroy(): void {
    if (this.routeParamSubscriber) {
      this.routeParamSubscriber.unsubscribe();
    }
    if (this.sectorIndustryStoreSubscriber) {
      this.sectorIndustryStoreSubscriber.unsubscribe();
    }
    if (this.sectorIndustryStoreReloadSubscriber) {
      this.sectorIndustryStoreReloadSubscriber.unsubscribe();
    }
    if (this.sectorIndustryStoreHasDataSubscriber) {
      this.sectorIndustryStoreHasDataSubscriber.unsubscribe();
    }
    if (this.industryDetailsSubscriber) {
      this.industryDetailsSubscriber.unsubscribe();
    }
    if (this.globalAppSettingSubscriber) {
      this.globalAppSettingSubscriber.unsubscribe();
    }
    if (this.valuationMetaSubscriber) {
      this.valuationMetaSubscriber.unsubscribe();
    }
    if (this.valuationDataSubscriber) {
      this.valuationDataSubscriber.unsubscribe();
    }
    if (this.valuationMcapEvLpriceDataSubscriber) {
      this.valuationMcapEvLpriceDataSubscriber.unsubscribe();
    }
    if (this.valuationMcapEvLpriceFirstBatchSubscriber) {
      this.valuationMcapEvLpriceFirstBatchSubscriber.unsubscribe();
    }
    if (this.valuationMcapEvLpriceSecondBatchSubscriber) {
      this.valuationMcapEvLpriceSecondBatchSubscriber.unsubscribe();
    }
    if (this.valuationDataFirstBatchSubscriber) {
      this.valuationDataFirstBatchSubscriber.unsubscribe();
    }
    if (this.valuationDataSecondBatchSubscriber) {
      this.valuationDataSecondBatchSubscriber.unsubscribe();
    }
    if (this.userTabSettingsSubscriber) {
      this.userTabSettingsSubscriber.unsubscribe();
    }
    if (this.lineItemsSubscriber) {
      this.lineItemsSubscriber.unsubscribe();
    }
    if (this.currencyMessageSubscriber) {
      this.currencyMessageSubscriber.unsubscribe();
    }
    if (this.userIndustrySettingsSubscriber) {
      this.userIndustrySettingsSubscriber.unsubscribe();
    }
    if (this.valuationDataService) {
      this.valuationDataService.destroyValuationGridData();
    }
    this.dismissSnackBar();
  }

  ngOnChanges(changes) {
    if (
      changes.state &&
      changes.state.currentValue &&
      changes.state.currentValue !== changes.state.previusValue
    ) {
      this.tickers = this.state.tickers;
      this.headerTitle = this.state.headerTitle;
      this.currency = this.state.currency;
    }

    if (
      changes.sortByColumnId &&
      changes.sortByColumnId.currentValue !==
        changes.sortByColumnId.previousValue
    ) {
      this.gridSortByColumnId = this.sortByColumnId;
    }

    if (
      (changes.routeParams &&
        changes.routeParams.currentValue &&
        changes.routeParams.currentValue !==
          changes.routeParams.previousValue) ||
      (changes.routeQueryParams &&
        changes.routeQueryParams.currentValue &&
        changes.routeQueryParams.currentValue !==
          changes.routeQueryParams.previousValue)
    ) {
      this.shouldFetchMeta = true;
    }

    if (
      changes.isActive &&
      changes.isActive.currentValue &&
      !changes.isActive.previousValue
    ) {
      if (this.shouldFetchMeta || changes.isActive.firstChange) {
        const isUserPageType = this.checkIfUserPageType();
        const metaPayload = isUserPageType
          ? getMetaPayloadFromUrls(
              this.routeParams,
              this.routeQueryParams,
              this.tabType,
              this.compType,
            )
          : getMetaPayloadFromUrls(
              this.routeParams,
              this.routeQueryParams,
              this.tabType,
              this.compType,
              this.state,
            );
        this.fetchAndUpdateComparativeMeta(metaPayload);
        this.shouldFetchMeta = false;
      } else if (
        this.shouldFetchData &&
        this.tickers &&
        this.tickers.length &&
        !changes.isActive.firstChange
      ) {
        this.fetchAndHandleValuationData();
      }
    }
  }

  //methods

  /**
   * It executes on industry change
   * Makes call to get Industry meta and updates the filters selection data according to it.
   * Makes call to get stdLines Info for the received tickers
   */
  fetchAndUpdateComparativeMeta(metaPayload) {
    this.shouldFetchMeta = false;
    this.isMetaInProgress = true;
    // reset filters on change of industry
    this.setDefaultFilters();

    if (this.valuationMetaSubscriber) {
      this.valuationMetaSubscriber.unsubscribe();
    }
    this.valuationMetaSubscriber = this.dataService
      .fetchComparativeAnalysisMeta(metaPayload)
      .subscribe(
        (response: { data: any; status: string; status_code?: number }) => {
          if (response.status === "success") {
            const responseData = response.data;
            this.headerTitle = responseData.comps_name;
            this.marketDataAccess = responseData.marketdata_access;
            if (!this.marketDataAccess) {
              this.snackbarInfo.message = `You are currently not entitled to view Market/Valuation data. Please reach out to your Customer Success Manager if you require access.`;
              this.snackbarInfo.type = "info";
              this.showSnackBarToastMessage(this.snackbarInfo);
            }

            // store meta information
            this.updateStateWithMeta(responseData);
            const selectedRatioLineIds = this.ratios
              ? getSelectedRatiosId(this.ratios.ratio_details)
              : undefined;

            if (responseData.ticker_info.length === 0) {
              this.isNoTickerPopupVisible = true;
            } else if (
              !selectedRatioLineIds ||
              selectedRatioLineIds.length === 0
            ) {
              this.snackbarInfo.message = "No data Available.";
              this.snackbarInfo.type = "info";
              this.showSnackBarToastMessage(this.snackbarInfo);
            }

            this.isMetaInProgress = false;
            if (
              !this.ratios ||
              !selectedRatioLineIds ||
              selectedRatioLineIds.length === 0 ||
              !this.tickers ||
              this.tickers.length === 0
            ) {
              this.gridData = undefined;
              this.valuationGridData$.next(this.gridData);
            } else {
              // make data calls

              this.fetchAndHandleValuationData();
              const tickerIds = this.tickers.map((item) => item.ticker);
              this.getPeriodsWithAvailableData(tickerIds);
            }

            if (responseData.ticker_info && responseData.ticker_info.length) {
              // Update stdLineItem on Tickers change
              const tickersWithOnlyId = responseData.ticker_info.map(
                (item) => item.ticker,
              );
              this.getRatioLineItemData(tickersWithOnlyId);
            }
          } else if (
            response.status_code === 403 &&
            window.location.href !== this.legacyUrl
          ) {
            window.location.href = `${this.legacyUrl}/home`;
          } else {
            console.error("Meta call failed");
          }
        },
      );
  }

  /**
   * reset filters selection
   */
  setDefaultFilters() {
    this.suggestedRatioLines = [];
    this.ratios = [];
    this.tickers = [];
    this.currency = "";
    this.periodData = undefined;
    this.orientationValue = "grid";
  }

  /**
   * store meta details to variables
   *  @param {obj} meta: meta details
   */
  updateStateWithMeta(meta) {
    this.ratios = meta.ratios;
    this.region = meta.region;
    this.currency = meta.currency || "USD";
    this.tickers = meta.ticker_info ? meta.ticker_info : [];
    this.periodData = meta.period_selector;
    const periodUserSettings = convertPeriodMetaToUserSettings(
      meta.period_selector,
    );
    this.periodUserSetting = periodUserSettings;
    this.periodList = getSelectedPeriods(meta.period);
    this.magnitudeMessage = meta.magnitude_message;
    this.periodCalculation = meta.period_calculation;
    this.selectedLineItemCount = (
      getSelectedRatiosId(meta.ratios.ratio_details) || []
    ).length;
    this.orientationValue = meta.orientation;
    this.updateValuationState.emit({
      tickers: this.tickers,
      headerTitle: this.headerTitle,
      currency: this.currency,
      ratios: this.ratios,
      periodUserSetting: this.periodUserSetting,
      orientationValue: this.orientationValue,
      loadingWithMeta: true,
    });
  }

  checkIfUserPageType() {
    return this.pageType === "user";
  }

  /**
   * It executes on the search and selection of line item
   * It adds this line item to existing list
   * @param {object} e: selected line item
   */
  onSearchedLi(e) {
    if (!e) {
      return;
    }

    const selectedRatioLineIds = this.ratios
      ? getSelectedRatiosId(this.ratios.ratio_details)
      : [];

    // check if already existing line items are more or equal to max limit. If yes don't add new item
    if (selectedRatioLineIds.length >= this.lineItemMaxLimit) {
      this.snackbarInfo.message = `Line item can not be added. You have reached the line item limit.`;
      this.snackbarInfo.type = "warning";
      this.showSnackBarToastMessage(this.snackbarInfo, null);
      return;
    }

    const value = { ...e, parent: undefined, sliid: e.sliid || e.sli_id };
    const alreadyExist = selectedRatioLineIds.includes(value.sliid);

    if (!alreadyExist) {
      this.isUserSettingUpdateInProgress = true;

      //update the selected check of ratio item
      const updatedRatios = this.ratios.ratio_details.map((item) => {
        const ratioItem = item.ratio;
        if (ratioItem.usliid === value.sliid) {
          item.ratio.selected = true;
        }
        return item;
      });

      const updatedRatiosObj = {
        ...this.ratios,
        ratio_details: updatedRatios,
      };

      const isUserPageType = this.checkIfUserPageType();
      if (isUserPageType) {
        this.isUserSettingUpdateInProgress = true;
        const selectedRatioId = getSelectedRatiosId(
          updatedRatiosObj.ratio_details,
        );
        const denom = getIsDenomSelected(updatedRatiosObj.include);
        const denomYoy = getIsDenomYoySelected(updatedRatiosObj.include);
        const lineItemToUpdate = {
          LineItem: {
            ratios: {
              names: selectedRatioId,
              denom: denom,
              denom_yoy: denomYoy,
            },
          },
        };
        const settingsPayload = updateCustomTableSettings(
          this.compId,
          TAB_BE_MAPPING.valuation,
          lineItemToUpdate,
        );
        this.dataService
          .updateCustomComps(settingsPayload)
          .subscribe((response) => {
            if (response.status === "success") {
              this.ratios = updatedRatiosObj;
              if (updatedRatios) {
                this.selectedRatioId = getSelectedRatiosId(updatedRatios) || [];
                this.selectedLineItemCount = this.selectedRatioId.length;
                this.orderedRatioData = this.orderedRatioData
                  ? this.orderedRatioData.concat(value)
                  : undefined;
              }
              this.selectedLineItemCount = (
                getSelectedRatiosId(this.ratios.ratio_details) || []
              ).length;
              this.updateValuationState.emit({ ratios: updatedRatiosObj });
              this.snackbarInfo.message = `${value.label} has been added to the table`;
              this.snackbarInfo.type = "success";
              this.showSnackBarToastMessage(this.snackbarInfo);
              this.fetchAndHandleValuationData();
              this.isUserSettingUpdateInProgress = false;
            }
            this.isUserSettingUpdateInProgress = false;
          });
      } else {
        this.ratios = updatedRatiosObj;
        if (updatedRatios) {
          this.selectedRatioId = getSelectedRatiosId(updatedRatios) || [];
          this.selectedLineItemCount = this.selectedRatioId.length;
          this.orderedRatioData = this.orderedRatioData
            ? this.orderedRatioData.concat(value)
            : undefined;
        }
        this.selectedLineItemCount = (
          getSelectedRatiosId(this.ratios.ratio_details) || []
        ).length;
        this.updateValuationState.emit({ ratios: updatedRatiosObj });
        this.snackbarInfo.message = `${value.label} has been added to the table`;
        this.snackbarInfo.type = "success";
        this.showSnackBarToastMessage(this.snackbarInfo);
        this.fetchAndHandleValuationData();
        this.isUserSettingUpdateInProgress = false;
        this.updateUnsavedDataStatus.emit();
      }
    } else {
      this.snackbarInfo.message = "This line item is already present.";
      this.snackbarInfo.type = "info";
      this.showSnackBarToastMessage(this.snackbarInfo);
    }
  }

  /**
   * It executes on the click of Edit button of lien item filter
   * It creates the Line item modal withe required information and opens it.
   */
  handleEditLineItemsButtonClick() {
    let selectedRatioItems = [];
    if (this.orderedRatioData) {
      selectedRatioItems = this.orderedRatioData;
    } else {
      selectedRatioItems = this.ratios.ratio_details
        .filter((item) => item.ratio.selected)
        .map((el) => {
          const sliId = el.ratio.usliid || el.ratio.sliid || el.ratio.el.sli_id;
          return {
            ...el.ratio,
            sli_id: sliId,
            name: el.ratio.label,
            is_valuation_ratio: true,
          };
        });
    }
    this.lineItemsModal = this.modalService.create({
      nzTitle: "Edit Line Items",
      nzOkLoading: true,
      nzContent: LineItemModalComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        addColTableData: selectedRatioItems,
        stdLineItems: this.ratioLineItemsData,
        max: this.lineItemMaxLimit,
        maxHeight: "290px",
        selectedPeriod: [],
        tickers: this.tickers,
        createSource: "consensus",
        ratioDenomData: this.ratios.include,
        showDenomCheckbox:
          this.orientationValue && this.orientationValue === "grid",
      },
      nzWrapClassName: "comps-modal-container vertical-center-modal",
      nzFooter: [
        {
          label: "Cancel",
          type: "default",
          onClick: (): void => {
            this.lineItemsModal.destroy();
          },
        },
        {
          label: "Update",
          type: "primary",
          class: "update-btn",
          nzClassName: (data) => {
            return data.modalData.length > data.max ? "disable" : "";
          },
          onClick: (data): void => {
            this.updateEditModalLineItems(data);
          },
          disabled: (data) => {
            return (
              data.modalData.length > data.max || data.modalData.length === 0
            );
          },
        },
      ],
    });
    this.dismissSnackBar();
  }

  /**
   * It adds line items selected from the edit modal to the list
   * @param {object} data: selected data from line item modal
   */
  updateEditModalLineItems(data) {
    const { modalData, selectedRatioDenomItems = [] } = data;
    this.orderedRatioData = [...modalData];
    this.isUserSettingUpdateInProgress = true;
    const selectedRatioItems = modalData.map(
      (item) => item.uniquesliid || item.sliid || item.sli_id,
    );
    //update the selected check of ratio item
    const updatedRatios = this.ratios.ratio_details.map((item) => {
      const ratioItem = item.ratio;
      item.ratio.selected = selectedRatioItems.includes(ratioItem.usliid);
      return item;
    });

    const updatedIncludes = this.ratios.include.map((item) => ({
      ...item,
      selected: selectedRatioDenomItems.includes(item.name),
    }));

    const updatedRatiosObj = {
      ratio_details: updatedRatios,
      include: updatedIncludes,
    };

    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const denom = getIsDenomSelected(updatedRatiosObj.include);
      const denomYoy = getIsDenomYoySelected(updatedRatiosObj.include);
      const lineItemToUpdate = {
        LineItem: {
          ratios: {
            names: selectedRatioItems,
            denom: denom,
            denom_yoy: denomYoy,
          },
        },
      };
      const settingsPayload = updateCustomTableSettings(
        this.compId,
        TAB_BE_MAPPING.valuation,
        lineItemToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.ratios = updatedRatiosObj;
            if (updatedRatios) {
              this.selectedRatioId = getSelectedRatiosId(updatedRatios) || [];
              this.selectedLineItemCount = this.selectedRatioId.length;
            }
            this.selectedLineItemCount = (
              getSelectedRatiosId(this.ratios.ratio_details) || []
            ).length;
            this.updateValuationState.emit({ ratios: updatedRatiosObj });
            this.fetchAndHandleValuationData();
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.ratios = updatedRatiosObj;
      if (updatedRatios) {
        this.selectedRatioId = getSelectedRatiosId(updatedRatios) || [];
        this.selectedLineItemCount = this.selectedRatioId.length;
      }
      this.selectedLineItemCount = (
        getSelectedRatiosId(this.ratios.ratio_details) || []
      ).length;
      this.updateValuationState.emit({ ratios: updatedRatiosObj });
      this.fetchAndHandleValuationData();
      this.isUserSettingUpdateInProgress = false;
      this.updateUnsavedDataStatus.emit();
    }

    this.lineItemsModal.destroy();
  }

  /**
   * Set the snackbar message and snackbarRef
   */
  showSnackBarToastMessage(info, duration = 5000) {
    this.snackbarMessage = info.message;
    this.snackBarRef = this.getSnackbarRef(info.type, duration);
  }

  /**
   * Hides the snack bar
   */
  dismissSnackBar() {
    if (this.snackBarRef) {
      this.snackBarRef.dismiss();
      this.overlayOn = false;
    }
  }

  /**
   * Shows snackbar message, according to (success | info | failure) template
   * @param {object} type - type of message (success | info | failure)
   */
  getSnackbarRef(type, duration = 5000) {
    const typeMap = {
      success: this.successTemplate,
      info: this.infoTemplate,
      failure: this.failureTemplate,
      warning: this.warningTemplate,
    };
    if (typeMap[type]) {
      if (type === "warning") {
        this.overlayOn = true;
      }
      return this.snackBar.openFromTemplate(typeMap[type], {
        panelClass: type,
        duration: duration,
        verticalPosition: "top",
      });
    }
    return undefined;
  }

  /**
   * Returns array of tickers id from array of tickers object.
   * @returns {array} - array of ticker id
   */
  getTickerIdArray() {
    return this.tickers ? this.tickers.map((item) => item.ticker) : [];
  }

  /**
   * It call the get_std_line_items api and formats the response
   */
  getRatioLineItemData(tickerIds) {
    if (this.lineItemsSubscriber) {
      this.lineItemsSubscriber.unsubscribe();
    }
    this.isLineItemUpdateInProgress = true;
    this.lineItemsSubscriber = this.valuationDataService
      .getStdLineItems(tickerIds)
      .subscribe((res) => {
        this.ratioLineItemsData = res.data.filter(
          (d) => d.tab_short_name === "SL" || d.tab_short_name === "VR",
        );
        if (this.ratios) {
          this.selectedRatioId =
            getSelectedRatiosId(this.ratios.ratio_details) || [];
          this.selectedLineItemCount = this.selectedRatioId.length;
        }
        const _suggestedLines: Array<any> = res.data.filter(
          (d) => d.tab_short_name === "SL",
        );
        this.suggestedRatioLines = _suggestedLines.length
          ? _suggestedLines[0].tab_sli_data.map((l) => {
              return {
                ...l,
                disabled: false,
                label: l.name,
                isLeaf: true,
                level: 2,
                header: false,
                sliid: l.sli_id,
                line_count: l.line_count,
                id: l.uniquesliid,
              };
            })
          : [];

        if (this.suggestedRatioLines.length > 0) {
          this.suggestedRatioLines = [
            {
              suggestion_header: "Suggestions: ",
              isLeaf: true,
              disabled: true,
            } as any,
          ]
            .concat(this.suggestedRatioLines)
            .concat({
              suggestion_footer: "Selected Line Items",
              isLeaf: true,
              disabled: true,
            } as any);
        } else {
          this.suggestedRatioLines = [
            {
              suggestion_header: "No suggestion found ",
              isLeaf: true,
              disabled: true,
            } as any,
          ]
            .concat(this.suggestedRatioLines)
            .concat({
              suggestion_footer: "Selected Line Items",
              isLeaf: true,
              disabled: true,
            } as any);
        }
        this.isLineItemUpdateInProgress = false;
      });
  }

  /**
   * get object required to make valuation data call
   */
  getDataCallObject() {
    return {
      ticker_info: this.tickers,
      currency: this.currency,
      period: this.periodData,
      ratios: this.ratios,
      period_calculation: this.periodCalculation,
      defaultOrientation: this.orientationValue,
      magnitudeMsg: this.magnitudeMessage,
    };
  }

  /**
   * It is used to trigger valuation data call for peer tab and store the result in gridData
   */
  fetchAndHandleValuationData() {
    this.onDataFetchInitiate.emit();
    if (this.valuationDataSecondBatchSubscriber) {
      this.valuationDataSecondBatchSubscriber.unsubscribe();
    }
    if (this.valuationDataFirstBatchSubscriber) {
      this.valuationDataFirstBatchSubscriber.unsubscribe();
    }
    if (this.valuationDataSubscriber) {
      this.valuationDataSubscriber.unsubscribe();
    }
    if (this.valuationMcapEvLpriceSecondBatchSubscriber) {
      this.valuationMcapEvLpriceSecondBatchSubscriber.unsubscribe();
    }
    if (this.valuationMcapEvLpriceFirstBatchSubscriber) {
      this.valuationMcapEvLpriceFirstBatchSubscriber.unsubscribe();
    }
    if (this.valuationMcapEvLpriceDataSubscriber) {
      this.valuationMcapEvLpriceDataSubscriber.unsubscribe();
    }
    this.isDataInProgress = true;

    this.store.dispatch(new DeleteDpParams());
    const dataCallObject = this.getDataCallObject();
    const orderedRatioItems = this.orderedRatioData
      ? this.orderedRatioData.map(
          (item) => item.uniquesliid || item.sliid || item.sli_id,
        )
      : undefined;
    let gridData = createGridData(
      dataCallObject,
      orderedRatioItems,
      this.disableTickerDeletionOnGrid,
    );
    this.gridData = { ...gridData };
    this.valuationGridData$.next(this.gridData);

    const ratios = [...this.gridData.ratios];

    const singleTickerCallCount = 18;
    const firstSetOfTicker = dataCallObject.ticker_info.slice(
      0,
      singleTickerCallCount,
    );
    const remainingSetOfTickers = dataCallObject.ticker_info.slice(
      singleTickerCallCount,
      dataCallObject.ticker_info.length,
    );

    const urls: Array<string> = createComparativeDataCallUrlV1(
      ratios,
      dataCallObject,
      firstSetOfTicker,
      singleTickerCallCount,
      this.isComparativeAnalysisCall,
    );

    const maxParallelCallsForMCapEVLastPrice = 1;
    const mCapEVLastPriceUrls: Array<string> = createDataCallUrlForMcapEvLp(
      dataCallObject,
      firstSetOfTicker,
      maxParallelCallsForMCapEVLastPrice,
    );

    let firstBatchSubscriptionIndex = 0;
    let firstBatchSubscriptionIndexForMcapEvLP = 0;
    this.valuationDataSubscriber = new Observable((observer) => {
      this.valuationDataFirstBatchSubscriber = from(urls)
        .pipe(
          mergeMap((url) => {
            return this.compsDataService.getCompsData(url);
          }),
        )
        .subscribe((response: { data; status }) => {
          if (response.status === "success") {
            const data = response.data;
            gridData = this.valuationDataService.addComparativeDataToGridV1(
              data,
              gridData,
              dataCallObject,
            );
          } else {
            console.error("Error while fetching valuation data");
          }
          firstBatchSubscriptionIndex++;
          if (
            (!remainingSetOfTickers || !remainingSetOfTickers.length) &&
            firstBatchSubscriptionIndex === urls.length
          ) {
            observer.next(gridData);
            observer.complete();
          }
        });

      if (remainingSetOfTickers && remainingSetOfTickers.length) {
        const maxParallelCallsForRemainingBatchOfTickers = 30;
        const nextBatchOfUrls: Array<string> = createComparativeDataCallUrlV1(
          ratios,
          dataCallObject,
          remainingSetOfTickers,
          maxParallelCallsForRemainingBatchOfTickers,
          this.isComparativeAnalysisCall,
        );
        let remainingBatchSubscriptionIndex = 0;
        this.valuationDataService
          .createDelayUsingTimer(1000)
          .pipe()
          .subscribe(() => {
            this.valuationDataSecondBatchSubscriber = from(nextBatchOfUrls)
              .pipe(
                mergeMap((url) => {
                  return this.compsDataService.getCompsData(url);
                }),
              )
              .subscribe((response: { data; status }) => {
                remainingBatchSubscriptionIndex++;
                if (response.status === "success") {
                  const data = response.data;
                  gridData =
                    this.valuationDataService.addComparativeDataToGridV1(
                      data,
                      gridData,
                      dataCallObject,
                    );
                } else {
                  console.error("Error while fetching valuation data");
                }
                if (
                  remainingBatchSubscriptionIndex === nextBatchOfUrls.length
                ) {
                  observer.next(gridData);
                  observer.complete();
                }
              });
          });
      }
    }).subscribe((gridData: ValuationGridData) => {
      this.gridData = { ...gridData };
      this.gridData = this.valuationDataService.calculateFooterData(
        gridData,
        dataCallObject.currency,
        this.calculateFooterDataForMCapAndEV,
      );
      this.valuationGridData$.next(this.gridData);
      this.isDataInProgress = false;
    });

    this.isMarketDataInProgress = true;
    this.valuationMcapEvLpriceDataSubscriber = new Observable((observer) => {
      this.valuationMcapEvLpriceFirstBatchSubscriber = from(mCapEVLastPriceUrls)
        .pipe(
          mergeMap((url) => {
            return this.compsDataService.getCompsData(url);
          }),
        )
        .subscribe((response: { data; status }) => {
          if (response.status === "success") {
            const data = response.data;
            gridData = this.valuationDataService.addDataToGridMcapEVLastPrice(
              data,
              gridData,
              dataCallObject,
            );
          } else {
            console.error(
              "Error while fetching Market Cap, Ev and Last Price Data",
            );
          }
          firstBatchSubscriptionIndexForMcapEvLP++;
          if (
            (!remainingSetOfTickers || !remainingSetOfTickers.length) &&
            firstBatchSubscriptionIndexForMcapEvLP ===
              mCapEVLastPriceUrls.length
          ) {
            observer.next(gridData);
            observer.complete();
          }
        });

      if (remainingSetOfTickers && remainingSetOfTickers.length) {
        const maxParallelCallsForRemainingBatchOfTickers = 3;
        const nextBatchOfUrls: Array<string> = createDataCallUrlForMcapEvLp(
          dataCallObject,
          remainingSetOfTickers,
          maxParallelCallsForRemainingBatchOfTickers,
        );
        let remainingBatchSubscriptionIndexForMcapEvLP = 0;
        this.valuationDataService
          .createDelayUsingTimer(1000)
          .pipe()
          .subscribe(() => {
            this.valuationMcapEvLpriceSecondBatchSubscriber = from(
              nextBatchOfUrls,
            )
              .pipe(
                mergeMap((url) => {
                  return this.compsDataService.getCompsData(url);
                }),
              )
              .subscribe((response: { data; status }) => {
                remainingBatchSubscriptionIndexForMcapEvLP++;
                if (response.status === "success") {
                  const data = response.data;
                  gridData =
                    this.valuationDataService.addDataToGridMcapEVLastPrice(
                      data,
                      gridData,
                      dataCallObject,
                    );
                } else {
                  console.error(
                    "Error while fetching Market Cap, Ev and Last Price Data",
                  );
                }
                if (
                  remainingBatchSubscriptionIndexForMcapEvLP ===
                  nextBatchOfUrls.length
                ) {
                  observer.next(gridData);
                  observer.complete();
                }
              });
          });
      }
    }).subscribe((gridData: ValuationGridData) => {
      this.gridData = { ...gridData };
      this.gridData = this.valuationDataService.calculateFooterDataForMcapEvLp(
        gridData,
        dataCallObject.currency,
      );
      this.valuationGridData$.next(this.gridData);
      this.isMarketDataInProgress = false;
    });
  }

  /**
   * This method is called on change of the orientation button.
   * It updates the value of Orientation in the state and calls
   * saveusersettings api to save it.
   * @param e orientation value
   */
  handleOrientation(e) {
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const oritentationToUpdate = {
        Orientation: {
          orientation: e,
        },
      };
      const settingsPayload = updateCustomTableSettings(
        this.compId,
        TAB_BE_MAPPING.valuation,
        oritentationToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.orientationValue = e;
            this.updateValuationState.emit({ orientationValue: e });
            this.store.dispatch(new DeleteDpParams());
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.orientationValue = e;
      this.updateValuationState.emit({ orientationValue: e });
      this.updateUnsavedDataStatus.emit();
      this.store.dispatch(new DeleteDpParams());
    }
  }

  /**
   * Executes on click of Period filter popup's Apply button.
   * It posts the selected period setting to user setting api
   * It emits `onPeriodChange` with selected periodData
   * @param {{updatedPeriodData: ValuationPeriodState, periodUserSettingData: PeriodUserSettingObj}} periodData: selected values from period filter popup
   */
  handlePeriodApply(periodData: {
    updatedPeriodData: ValuationPeriodState;
    periodUserSettingData: PeriodUserSettingObj;
  }) {
    const { updatedPeriodData, periodUserSettingData } = periodData;

    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const periodToUpdate = {
        Period: periodData.periodUserSettingData,
      };
      const settingsPayload = updateCustomTableSettings(
        this.compId,
        TAB_BE_MAPPING.valuation,
        periodToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.periodData = updatedPeriodData;
            this.periodUserSetting = periodUserSettingData;
            this.fetchAndHandleValuationData();
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.periodData = updatedPeriodData;
      this.periodUserSetting = periodUserSettingData;
      this.fetchAndHandleValuationData();
      this.updateValuationState.emit({
        periodData: updatedPeriodData,
        periodUserSetting: periodUserSettingData,
      });
      this.updateUnsavedDataStatus.emit();
    }
  }

  /**
   * This function is fired when the save currency event is fired from the currency filter component.
   * It updates the currency in the state and calls the saveusersettings api to save it.
   * @param item selected currency
   */
  updateCurrency(item: string) {
    if (!item) {
      return;
    }
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const currencyToUpdate = {
        Currency: {
          currency_iso: item,
        },
      };
      const settingsPayload = updateCustomTableSettings(
        this.compId,
        TAB_BE_MAPPING.valuation,
        currencyToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.currency = item;
            this.currencyMessageSubscriber = this.compsDataService
              .getCurrencyMessage(item)
              .subscribe((res) => {
                if (res["status"] === "success") {
                  this.magnitudeMessage = res["magnitude_message"];
                  this.fetchAndHandleValuationData();
                } else {
                  this.snackbarInfo.message = "Could not update currency";
                  this.snackbarInfo.type = "failure";
                  this.showSnackBarToastMessage(this.snackbarInfo);
                }
                this.updateValuationState.emit({
                  currency: this.currency,
                  magnitudeMessage: res["magnitude_message"],
                });
              });
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.currency = item;
      this.currencyMessageSubscriber = this.compsDataService
        .getCurrencyMessage(item)
        .subscribe((res) => {
          if (res["status"] === "success") {
            this.magnitudeMessage = res["magnitude_message"];
            this.fetchAndHandleValuationData();
          } else {
            this.snackbarInfo.message = "Could not update currency";
            this.snackbarInfo.type = "failure";
            this.showSnackBarToastMessage(this.snackbarInfo);
          }
          this.updateValuationState.emit({
            currency: this.currency,
            magnitudeMessage: res["magnitude_message"],
          });
        });
      this.updateUnsavedDataStatus.emit();
    }
  }

  /**
   * It creates user tab settings object
   * @param {object} ratio - ratio data
   * @param {object} period - period settings
   * @param {object} orientation - selected orientation value
   * @return {object} user tab setting object which is used to save the selected filters
   */
  createUserTabSettings(
    ratios,
    period: PeriodUserSettingObj,
    orientation: string,
  ) {
    const selectedRatioId = getSelectedRatiosId(ratios.ratio_details);
    const denom = getIsDenomSelected(ratios.include);
    const denomYoy = getIsDenomYoySelected(ratios.include);
    return {
      ratios: {
        names: selectedRatioId,
        denom,
        denom_yoy: denomYoy,
      },
      period,
      orientation,
      industry_id: this.industryId,
      subindustry_id: [this.subGroup],
    };
  }

  updateTickerOrder(tickerOrderedList) {
    this.sortedTickers = tickerOrderedList;
  }

  /**
   * Executes on click of export dropdown list item
   * It closes the dropdown on selecting list items. Also one can update the loader status when excel to export action is in progress
   * @param {id} number Indicates the id of selected list item from optionList
   */
  handleETEListItemClick(exportType) {
    this.isExportInProgress = true;
    const tabName = "Valuation";
    let templateType = "";
    if (this.orientationValue === "grid") {
      templateType = "industry valuation grid";
    }
    if (this.orientationValue === "list") {
      templateType = "industry valuation list";
    }
    const tickerCids = this.sortedTickers.map((item) => {
      return item.companyid || item.company_id || item.cid;
    });
    const state = {
      tickers: this.tickers,
      currency: this.currency,
      ratios: this.ratios,
      periodUserSetting: this.periodUserSetting,
      orientationValue: this.orientationValue,
    };
    const valuationDetails = createValuationTabUserSettings(
      state,
      tickerCids,
      false,
    );

    const payload = {
      ...valuationDetails,
      tab_type: tabName,
      comp_type: this.compType,
      comps_name: this.headerTitle,
    };
    this.dataService
      .downloadComparativeExport(payload, templateType, tabName, exportType)
      .subscribe(
        (res) => {
          if (res["status"] === "success") {
            const fileName = res["filename"];
            const trackerId = res["trackerid"];
            const downloadUrl = `/api/excel_file_download?exceltrackerid=${trackerId}`;
            const startIFrameTime = new Date().getTime();
            const iFrameToLoad = this._document.createElement("iframe");
            const body = this._document.getElementsByTagName("body")[0];
            iFrameToLoad.id = `${fileName}`;
            iFrameToLoad.name = `${fileName}`;
            iFrameToLoad.src = downloadUrl;
            iFrameToLoad.setAttribute(
              "style",
              "visibility:hidden;display:none",
            );
            body.appendChild(iFrameToLoad);

            const checkInterval = setInterval(() => {
              const iFrameToGet = this._document.getElementById(
                `${fileName}`,
              ) as HTMLIFrameElement;
              const iFrame =
                iFrameToGet.contentDocument ||
                iFrameToGet.contentWindow.document;
              /*
          This check will run till the iFrame either doesn't load or for a max of 30secs
          Or till the ready state of the iFrame doesn't evaluate
        */
              if (
                iFrame.readyState === "complete" ||
                iFrame.readyState === "interactive" ||
                new Date().getTime() - startIFrameTime > 30000
              ) {
                //Commenting for now
                // this._document
                //   .getElementById(`research_download_${dataToPass.id}`)
                //   .remove();
                clearInterval(checkInterval);
                return;
              }
            }, 2000);
            this.isExportInProgress = false;
            // iframe.onload = () => {
            //   setTimeout(function() {
            //     document.getElementById(`research_download_${dataToPass.id}`).remove();
            //   }, 100);
            //   this.loading = false;
            // };
          } else {
            this.isExportInProgress = false;
            this.snackbarInfo.message =
              "Valuation export couldn't be downloaded.";
            this.snackbarInfo.type = "failure";
            this.showSnackBarToastMessage(this.snackbarInfo);
          }
        },
        (err) => {
          this.isExportInProgress = false;
          console.error(err);
        },
      );
  }

  /**
   * Handler for mega menu visibility change event
   */
  onMegaMenuVisibilityChange(isVisible: boolean) {
    this.isMegaMenuVisible = isVisible;
  }

  getPeriodsWithAvailableData(tickerIds) {
    this.appService
      .getPeriodsWithData(tickerIds)
      .subscribe((response: { status; dataAvailable }) => {
        if (response.status === "success") {
          this.periodsWithAvailableData = response.dataAvailable;
        }
      });
  }

  editTickers() {
    this.tickersModal = this.modalService.create({
      nzTitle: "Edit Tickers",
      nzContent: ComparativeTickerModalComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        addRowTableData: this.tickers, //this.addRowTableData,
        suggestedPeers: {
          watchername: "Suggested Peers",
          company_info: this.suggestedPeers,
        },
        recentlyVisitedCompanies: {
          company_info: this.recentlyVisitedCompanies
            ? [...this.recentlyVisitedCompanies]
            : [],
          watchername: "Recently viewed (up to 30)",
        },
        industryData: this.industryMenuData ? [...this.industryMenuData] : [],
        watchlistData: this.watchlistData ? [...this.watchlistData] : [],
        watchlistName: this.headerTitle,
        marketGeoData: this.marketGeoData
          ? { ...this.marketGeoData }
          : undefined,
        maxHeight: "340px",
        mpt: 1, //this.mpt,
        type: "edit",
        maxTickers: this.tickerLimit,
      },
      nzWrapClassName: "comps-modal-container vertical-center-modal",
      // nzWrapClassName: "watchlist-modal-container search-and-add-modal-container",
      nzFooter: [
        {
          label: "Cancel",
          type: "default",
          onClick: (): void => {
            this.tickersModal.destroy();
          },
        },
        {
          label: "Update",
          type: "primary",
          class: "update-btn",
          onClick: (data): void => {
            this.updateTickers(data);
          },
          disabled: (data) => {
            return (
              data["watchlistError"] !== "" ||
              data["modalData"].length > this.tickerLimit ||
              data["modalData"].length === 0
            );
          },
        },
      ],
    });
  }

  saveWatchlist(watchistError, modalData, watchlistName) {
    const tickerList = modalData.map((item) => {
      return item.ticker;
    });
    if (
      watchistError === "" &&
      watchlistName &&
      watchlistName.length > 0 &&
      tickerList.length > 0
    ) {
      const jsonData = {
        watchername: watchlistName,
        tickerlist: tickerList,
      };
      // this.isLoadingSaveWatchlist = true;
      let watchlistId = "";
      this.watchlistDataService.saveWatchlist(jsonData).subscribe(
        (response) => {
          if (response.status === "success") {
            watchlistId = response.watchlistid.toString();
            this.addWatchlistStore(watchlistId, watchlistName);
            this.initiateWatchlistFetch.emit();
          }
          this.snackbarInfo.message = `${watchlistName} saved as a new watchlist`;
          this.snackbarInfo.type = "info";
          this.showSnackBarToastMessage(this.snackbarInfo);
        },
        (error) => {
          // this.isLoadingSaveWatchlist = false;
          console.error(error);
        },
      );
    }
  }

  addWatchlistStore(watchlistId, watchlistName) {
    const payload = {
      respData: {
        watchlistId: Number(watchlistId),
        label: watchlistName,
      },
      key: this.storeDataKey,
    };
    this.store.dispatch(new AddWatchlistData(payload));
  }

  updateTickers(data) {
    const { modalData, watchlistName, watchlistError } = data;
    this.tickersModal.destroy();
    // FOR SAVING WATCHLIST
    if (data.saveWatchlist) {
      this.saveWatchlist(watchlistError, modalData, watchlistName);
    }
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const tickerToUpdate = {
        Ticker: {
          cids: modalData.map(
            (item) => item.company_id || item.cid || item.companyid,
          ),
        },
      };
      const settingsPayload = updateCustomTableSettingsForTickers(
        this.compId,
        TAB_BE_MAPPING.valuation,
        tickerToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.tickers = modalData;
            this.fetchAndHandleValuationData();

            this.updateValuationState.emit({ tickers: modalData });
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.tickers = modalData;
      this.fetchAndHandleValuationData();

      this.updateValuationState.emit({ tickers: modalData });
      this.updateGridSortByColumnId.emit();
      this.updateUnsavedDataStatus.emit();
    }
  }

  onSearchTickerSelection(tickerData) {
    const { value } = tickerData;
    let checIfTickerExist = false;
    for (const item of this.tickers) {
      if (item.ticker === value.ticker) {
        checIfTickerExist = true;
        this.snackbarMessage = "This ticker is already present.";
        this.snackBarRef = this.snackBar.openFromTemplate(this.infoTemplate, {
          panelClass: "info",
          duration: 5000,
          verticalPosition: "top",
        });
      }
    }
    if (!checIfTickerExist && this.tickers.length <= this.tickerLimit) {
      this.updateSearchedTicker(tickerData);
    }
  }

  updateSearchedTicker(selectedTicker) {
    const tickerObj = {
      full_name: selectedTicker.value.name || selectedTicker.value.full_name,
      name: selectedTicker.value.name || selectedTicker.value.full_name,
      ticker: selectedTicker.value.ticker,
      company_id: selectedTicker.value.cid,
    };
    const allTickers = this.tickers.concat(tickerObj);
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const tickerToUpdate = {
        Ticker: {
          cids: allTickers.map(
            (item) => item.company_id || item.cid || item.companyid,
          ),
        },
      };
      const settingsPayload = updateCustomTableSettingsForTickers(
        this.compId,
        TAB_BE_MAPPING.valuation,
        tickerToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.tickers = allTickers;
            this.fetchAndHandleValuationData();

            this.updateValuationState.emit({ tickers: allTickers });
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.tickers = allTickers;
      this.fetchAndHandleValuationData();

      this.updateValuationState.emit({ tickers: allTickers });
      this.updateGridSortByColumnId.emit();
      this.updateUnsavedDataStatus.emit();
    }
    this.snackbarInfo.message = `${selectedTicker.value.ticker}  has been added to the Table.`;
    this.snackbarInfo.type = "success";
    this.showSnackBarToastMessage(this.snackbarInfo);
  }

  getSortByColumnId() {
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.gridSortByColumnId = "";
    } else if (this.gridSortByColumnId === undefined) {
      this.gridSortByColumnId = "marketCap";
    }
    return this.gridSortByColumnId;
  }
}
